import React from 'react';

import { useTranslation } from '../../i18n';

const GroupCountLabel = ({
  label,
  count,
  total,
}: {
  label: string;
  count: number;
  total: number;
}) => {
  const { t } = useTranslation();
  return <>{`${label} (${t('GROUP_COUNT', { count, total })})`}</>;
};

export default GroupCountLabel;
